import "swiper/css";
import "swiper/css/pagination";
import { Container } from "@mui/material";
import { Pagination, EffectCoverflow, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";

import "./homePage.scss";

const contents = [
  {
    icon: "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Quintessential-choice-icon/Immediateassetprocurement..png",
    title: "Immediate asset procurement",
    content:
      "Lightning-fast asset procurement with all sizes of assets delivered straight to your door and installed right according to your space fit. ",
  },
  {
    icon: "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Quintessential-choice-icon/StrongDurableproducts.png",
    title: "Strong & durable products",
    content:
      "We've got you covered with a lasting value of Quality! Our procurement prowess delivers top-tier products that stands the test of time.",
  },
  {
    icon: "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Quintessential-choice-icon/SecuredRentalCycle.png",
    title: "Secured rental cycle",
    content:
      "From start to finish, we handle asset maintenance for a worry-free rental experience throughout the rental tenure.",
  },
  {
    icon: "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Quintessential-choice-icon/RelocationDoor-stepDelivery.png",
    title: "Relocation & door-step delivery",
    content:
      "Whether it's a local move or across India, we provide top-notch relocation services. From packaging to pickup and delivery, we handle it all.",
  },
  {
    icon: "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Quintessential-choice-icon/FlexibleTenure.png",
    title: "Flexible tenure",
    content:
      "Experience the freedom to change and rotate furniture after each tenure. Unlock the joy of reimaging your spaces with different assets regularly.",
  },
  {
    icon: "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Quintessential-choice-icon/CustomizationBranding.png",
    title: "Customization & branding",
    content:
      "Amplify brand recognition and accelerate business growth through our comprehensive bulk asset rentals with customization and branding solutions.",
  },
  {
    icon: "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Quintessential-choice-icon/AnytimeUpgradation.png",
    title: "Ease of upgradation",
    content:
      "We guarantee timely asset upgrades, aligning you with the global advancements and outpacing your competitors.",
  },
  {
    icon: "https://d5r8zwzwkh326.cloudfront.net/new+ui+images/home+page/Quintessential-choice-icon/Designercuratedpackages.png",
    title: "Designer curated packages",
    content:
      "Our experts assist you to craft custom packages to match your business aesthetics, blending tech and elegance for your space.",
  },
];

const QuintessentialChoice = () => {
  return (
    <div className="section-three">
      <Container maxWidth="lg">
        <h2 className="q-c-header">
          Why are we the
          <br />
          <span style={{ color: "#e96c4c" }}>Quintessential choice?</span>
        </h2>
      </Container>
      <div className="q-c-container">
        <Container maxWidth="lg">
          <div className="q-c-items-desktop-view">
            {contents.map((item, index) => (
              <div className="q-c-items-container" key={index}>
                <span className="q-c-items-icon">
                  <img src={item.icon} alt="icons" />
                </span>
                <span className="q-c-items-title">{item.title}</span>
                <p className="q-c-items-content">{item.content}</p>
              </div>
            ))}
          </div>
          <div className="q-c-items-mobile-view">
            <Swiper
              pagination={{ clickable: true }}
              effect={"coverflow"}
              grabCursor={true}
              centeredSlides={true}
              slidesPerView={"auto"}
              loop={true}
              coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              modules={[EffectCoverflow, Pagination, Autoplay]}
              className="mySwiper"
              autoplay={{ delay: 4000 }}
            >
              {[0, 2, 4, 6].map((startIndex) => (
                <SwiperSlide key={startIndex}>
                  <div className="all-q-c-items-slide">
                    {contents
                      .slice(startIndex, startIndex + 2)
                      .map((item, index) => (
                        <div className="q-c-items-mobile" key={index}>
                          <span className="q-c-items-icon">
                            <img src={item.icon} alt="icons" />
                          </span>
                          <span className="q-c-items-title">{item.title}</span>
                          <p className="q-c-items-content">{item.content}</p>
                        </div>
                      ))}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default QuintessentialChoice;
